var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-subheader',[_vm._v(_vm._s(_vm.getObjectValue('name', _vm.part)))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.save}},[_vm._v("Save Part")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }